<template>
  <div class="containerP">
      <div class="painel">
          <img src="/sandboxfront/igpm/P.png" alt="" style="margin-top:150px;">
      </div>      
      <div class="conteudoPrincipal">
          <p class="p">Esta calculadora auxilia na elaboração de cálculos dos principais índices econômicos brasileiros. Tais indicadores são estatísticas utilizadas para analisar o desempenho econômico de determinada área da economia.</p>
            <Categorias />
      </div>
  </div>
</template>

<script>

export default {
    data(){
        return{      
             
        }
    },
     created(){
            document.documentElement.scrollTop = 0;
    } 
    
}
</script>


<style lang="scss">

.containerP{
    margin:0 auto;
    max-width: 1160px; 
    background: #fff;
    min-height:100vh;
}
.painel{
    background-image: url('/sandboxfront/IGPM/f.png');
    background-color: #AF3437;
    background-size: cover;
    background-blend-mode: multiply;
    height: 540px;
    display: flex;
    justify-content: center;
    align-items: flex-start;   
    background-repeat: no-repeat;
    
}

.conteudoPrincipal{
    max-width: 1060px;
    margin:0px  auto;
    position: relative;
    top:-110px;
    background: #fff;
    height: 55vh;
    border-radius: 50px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding:20px;
    box-shadow: 0px 3px 6px #00000029;  
}
.conteudoPrincipal .p{
    width: 600px;
    text-align: center;
    font-weight: 600;
    font-size: 20px;
    margin-top:15px;
}

@media only screen and (max-width: 600px) {
  .painel{
    height: 23vh;
  }  
}
</style>
